import { Dropdown, Form, Input, Menu } from 'antd';

export function InputDropdownField({
  placeholder = '',
  required = false,
  inputProps = undefined,
  rules = [],
  items = [],
  disabled,
  form,
  ...props
}) {
  return (
    <Dropdown
      overlay={
        <Menu items={items} style={{ maxWidth: 500 }} onClick={(ss) => form.setFieldValue(props.name, ss.key)} />
      }
    >
      <Form.Item
        rules={[{ required, message: `กรุณากรอก${props.label}` }, ...rules]}
        noStyle={inputProps?.type === 'hidden'}
        {...props}
      >
        <Input {...inputProps} placeholder={placeholder || `กรอก${props.label}`} disabled={disabled} />
      </Form.Item>
    </Dropdown>
  );
}
